import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import EventTrigger from 'helpers/EventTrigger';

const Loader = ({isRTL, from, to, text}) => {
  const title = isRTL ? `${to} - ${from}` : `${from} - ${to}`;

  return (
    <>
      <div className="card card-block">
        <div className="grid">
          <div className="grid-item">
            <h3 className="mb-0">{title}</h3>
            <div className="text-muted">{text}</div>
          </div>
          <div className="grid-item-auto">
            <div className="position-relative w-6 h-6">
              <div className="loader-line-mask">
                <div className="loader-line"/>
              </div>
              <div className="loader-flights"/>
            </div>
          </div>
        </div>
      </div>
      <EventTrigger id="loader-ad" className="loader-ads" event="loaderAdRendered" />
    </>
  );
};

Loader.propTypes = {
  isRTL: PropTypes.bool.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default observer(Loader);
